// ---------------------------------------------------------------------------
// cities/index.ts — Aggregates all city content records
// ---------------------------------------------------------------------------
import type { CityRecord } from './types';

export type { CityRecord, CityLandingContent, CityConstants } from './types';

import { DUBAI_CITY } from './dubai.content';
import { BANGKOK_CITY } from './bangkok.content';
import { LONDON_CITY } from './london.content';
import { NEW_YORK_CITY } from './new-york.content';
import { SINGAPORE_CITY } from './singapore.content';
import { PARIS_CITY } from './paris.content';
import { TOKYO_CITY } from './tokyo.content';
import { ISTANBUL_CITY } from './istanbul.content';
import { SYDNEY_CITY } from './sydney.content';
import { LOS_ANGELES_CITY } from './los-angeles.content';
import { DELHI_CITY } from './delhi.content';

/** Slug → CityRecord map for all city landing pages */
export const CITY_CONTENT: Record<string, CityRecord> = {
  'hotel-software-dubai': DUBAI_CITY,
  'hotel-software-bangkok': BANGKOK_CITY,
  'hotel-software-london': LONDON_CITY,
  'hotel-software-new-york': NEW_YORK_CITY,
  'hotel-software-singapore': SINGAPORE_CITY,
  'hotel-software-paris': PARIS_CITY,
  'hotel-software-tokyo': TOKYO_CITY,
  'hotel-software-istanbul': ISTANBUL_CITY,
  'hotel-software-sydney': SYDNEY_CITY,
  'hotel-software-los-angeles': LOS_ANGELES_CITY,
  'hotels-in-delhi': DELHI_CITY,
};
